import React from 'react';
import { createElementClassName } from './tableControlsLayoutStyles';

type Props = {
  primaryControlsNode: React.ReactNode;
  secondaryControlsNode: React.ReactNode;
};

export const TableControlsLayout = (props: Props) => {
  const { primaryControlsNode, secondaryControlsNode } = props;

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('primary-slot')}>
        {primaryControlsNode}
      </div>
      <div className={createElementClassName('secondary-slot')}>
        {secondaryControlsNode}
      </div>
    </div>
  );
};
